import React from "react";
import { Api } from "../../api";
import DocViewer from "../DocViewer";

interface IProps {
  documentId: string;
}
export default function PacketViewDocument(props: IProps) {
  const { documentId } = props;
  const [url, setUrl] = React.useState("");

  React.useEffect(() => {
    if (documentId) {
      Api.documents.getUrl(documentId).then(result => {
        setUrl(result.data.data);
      });
    }
  }, [documentId]);

  return <>{url ? <DocViewer source={url} preview={true} /> : null}</>;
}
